import {
  Routes,
  Route,
  RoutesProps,
} from "react-router-dom";
import React, { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import DefaultPage from "../components/Common/DefaultPage";

const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const ForgotPassword = React.lazy(() => import("../components/Login/ForgotPassword"));
  const Otp = React.lazy(() => import("../components/Login/Otp"));
  const ResetPassword = React.lazy(() => import("../components/Login/ResetPassword"));
  const ChangePassword = React.lazy(() => import("../components/Login/ChangePassword"));
  const Home = React.lazy(() => import("../components/Home/Home"));
  const Signup = React.lazy(() => import("../components/Signup/Signup"));
  const SuccessSent = React.lazy(() => import("../components/Login/Success"));
  const UpdateOutletStatus = React.lazy(() => import("../components/WebHome/UpdateOutletStatus"));
  const StockistReport = React.lazy(() => import("../components/Stockist/StockistReportSearch"));
  const StockistReportStatus = React.lazy(() => import("../components/Stockist/StockistReport"));
  const HomeReport = React.lazy(() => import("../components/Stockist/StockistHomeReport"));
  const UserFranchisee = React.lazy(() => import("../components/Stocks/UserFranchisee"));
  const Stocks = React.lazy(() => import("../components/Stocks/Stocks"));
  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route path="/login" element={<Suspense fallback={<></>}> <Login /> </Suspense>} />
          <Route path="/forgot-password" element={<Suspense fallback={<></>}> <ForgotPassword /> </Suspense>} />
          <Route path="/otp" element={<Suspense fallback={<></>}> <Otp /> </Suspense>} />
          <Route path="/reset-password" element={<Suspense fallback={<></>}> <ResetPassword /> </Suspense>} />
          <Route path="/success" element={<Suspense fallback={<></>}> <SuccessSent /> </Suspense>} />
          <Route path="/change-password" element={<Suspense fallback={<></>}> <ChangePassword /> </Suspense>} />

          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />}>
            <Route path="/home" element={<Suspense fallback={<></>}> <Home /> </Suspense>} />
            <Route path="/home/report" element={<Suspense fallback={<></>}> <HomeReport /> </Suspense>} />
            <Route path="/signup" element={<Suspense fallback={<></>}> <Signup /> </Suspense>} />
            <Route path="/update-outlet-status" element={<Suspense fallback={<></>}> <UpdateOutletStatus /> </Suspense>} />

            <Route path="/stockist-report" element={<Suspense fallback={<></>}> <StockistReport /> </Suspense>} />
            <Route path="/stockist-report-status" element={<Suspense fallback={<></>}> <StockistReportStatus /> </Suspense>} />

            <Route path="/stocks" element={<Suspense fallback={<></>}> <UserFranchisee /> </Suspense>} />
            <Route path="/stock-details" element={<Suspense fallback={<></>}> <Stocks /> </Suspense>} />
          </Route>
          <Route
            index
            element={<Suspense fallback={<></>}> <DefaultPage /> </Suspense>}
          />

        </Routes >
      </div >
    </>
  );
};

export default Navigation;
